import type { ReactNode } from 'react';

type SelectableRowProps = {
  testId: string;
  isSelected: boolean;
  layoutClassName: string;
  children: ReactNode;
};

type SelectableRowLabelProps = {
  checkboxId: string;
  describedById?: string;
  isSelected: boolean;
  onToggle: () => void;
  children: ReactNode;
};

export function SelectableRowLabel({
  checkboxId,
  describedById,
  isSelected,
  onToggle,
  children,
}: Readonly<SelectableRowLabelProps>) {
  return (
    <label
      htmlFor={checkboxId}
      className="flex min-w-0 flex-1 cursor-pointer items-center gap-4"
    >
      <input
        id={checkboxId}
        type="checkbox"
        className="h-4 w-4 shrink-0 cursor-pointer accent-prim-600"
        checked={isSelected}
        aria-describedby={describedById}
        onChange={onToggle}
      />
      <span className="flex min-w-0 flex-1 flex-col gap-0.5">{children}</span>
    </label>
  );
}

export function SelectableRow({
  testId,
  isSelected,
  layoutClassName,
  children,
}: Readonly<SelectableRowProps>) {
  return (
    <div
      data-testid={testId}
      className={`${layoutClassName} rounded-xl border px-4 py-3 transition-all ${
        isSelected
          ? 'border-prim-300 bg-prim-50 shadow-sm'
          : 'border-neut-border bg-neut-bg-alt hover:border-neut-300 hover:bg-neut-50'
      }`}
    >
      {children}
    </div>
  );
}
